/* jshint esversion: 8, node: true */
export const APPSTORES_FORWARDING_URL = "https://onelink.to/h7upgy"

export const MEMODIO_CDN_URL = "https://memodioh44-1dd46.kxcdn.com"

export const SUPPORT_EMAIL = "support@memodio-app.com"
